import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalApp } from "../global";
import { Subscription } from "rxjs";
import {DataOnDemandService} from '../../api/services/data-on-demand.service';

@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.css"],
})
export class NavMenuComponent implements OnInit, OnDestroy {
  isExpanded = false;
  loggedIn = false;
  admin = false;
  supportAdmin = false;
  emailAddress = "";
  reportOnly = false;

  isLoggedInSubscription: Subscription = null;
  isAdminSubscription: Subscription = null;
  isSupportAdminSubscription: Subscription = null;
  currentUserNameSubscription: Subscription = null;
  reportOnlySubscription: Subscription = null;

  isInteractiveUser: boolean = false;
  isReportExportUser: boolean = false;
  isEmbeddedUser: boolean = false;
  hasReportLayouts: boolean = false;
  hasDodLayouts: boolean = false;

  constructor(public app: GlobalApp, private router: Router, private dodService: DataOnDemandService) {}

  ngOnInit() {
    this.isLoggedInSubscription = this.app.isLoggedIn.subscribe((result) => {
      this.loggedIn = result;
    });

    this.isAdminSubscription = this.app.isAdmin.subscribe((result) => {
      this.admin = result;
    });

    this.isSupportAdminSubscription = this.app.isSupportAdmin.subscribe((result) => {
      this.supportAdmin = result;
    });

    this.currentUserNameSubscription = this.app.currentUserName.subscribe(
      (result) => {
        this.emailAddress = result;
      }
    );

    this.reportOnlySubscription = this.app.userState.subscribe((userState) => {
      this.reportOnly = userState.reportOnly;

      this.isInteractiveUser = userState.isInteractiveUser;
      this.isReportExportUser = userState.isReportExportUser;
      this.isEmbeddedUser = userState.isEmbeddedUser;

      userState.interactives.forEach(interactive => {
        if (!this.hasReportLayouts) {
          this.hasReportLayouts = interactive.allowPrintOnDemand;
        }
      })
    });

    this.dodService.dataOnDemandGetUserAvailableDodEndPoints().subscribe(dodEndPoints => {
      if (dodEndPoints && dodEndPoints.length > 0) {
        this.hasDodLayouts = true;
      } else {
        this.hasDodLayouts = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();
    }

    if (this.isAdminSubscription) {
      this.isAdminSubscription.unsubscribe();
    }

    if (this.isSupportAdminSubscription) {
      this.isSupportAdminSubscription.unsubscribe();
    }

    if (this.currentUserNameSubscription) {
      this.currentUserNameSubscription.unsubscribe();
    }

    if (this.reportOnlySubscription) {
      this.reportOnlySubscription.unsubscribe();
    }
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  logOut() {
    this.app.logOut();

    this.router.navigate(["/"]);
  }
}
